import type { FormDataAdapter } from "$lib/util"
import {
  ACCEPTED_COUNTRIES_OPTIONS,
  Address,
  USA_COUNTRY_CODE,
  ValidateYup,
} from "@tastyworks/tastyworks-api"
import type { Alpha3Code } from "i18n-iso-countries/index"
import { mixed, object, string, type InferType } from "yup"

const ZIP_CODE_REGEX = /^\d{5}$/
const isDomestic = (country: string) => USA_COUNTRY_CODE === country

export const addressSchema = ValidateYup.addressSchema.concat(
  object({
    country: mixed<Alpha3Code>()
      .required("Required")
      .oneOf(Array.from(ACCEPTED_COUNTRIES_OPTIONS))
      .default(USA_COUNTRY_CODE),
    postalCode: string().when("country", {
      is: isDomestic,
      then: (fieldSchema) =>
        fieldSchema.required().matches(ZIP_CODE_REGEX, {
          message: "yup.common.postalCode.invalid",
          excludeEmptyString: true,
        }),
      otherwise: (fieldSchema) => fieldSchema.nullable(),
    }),
  })
)

export const addressAdapter: FormDataAdapter<
  Address,
  InferType<typeof addressSchema>
> = {
  toForm: (address, formData) => {
    formData.streetOne = address.streetOne
    formData.streetTwo = address.streetTwo
    formData.city = address.city
    formData.country = address.country
    formData.stateRegion = address.stateRegion
    formData.postalCode = address.postalCode

    return formData
  },
  toModel: (formData, address) => {
    address.streetOne = formData.streetOne
    address.streetTwo = formData.streetTwo ?? ""
    address.city = formData.city
    address.country = formData.country
    address.stateRegion = formData.stateRegion ?? ""
    address.postalCode = formData.postalCode ?? ""

    return address
  },
}
